<template>
  <div class="c-startpage-hero-element-countdown">
    <template v-if="!pending && remaining !== null && remaining !== undefined && !remaining.isempty">
      <div class="frame">
        <div class="message">{{ message }}</div>
        <div class="counter" :class="counterclass">
          <div class="value day">
            <div class="digits">
              <div class="digit" v-for="entry in remaining.days" :key="entry">{{ entry }}</div>
            </div>
            <div class="label">{{ labelTextDay }}</div>
          </div>
          <div class="value hour">
            <div class="digits">
              <div class="digit" v-for="entry in remaining.hours" :key="entry">{{ entry }}</div>
            </div>
            <div class="label">{{ labelTextHour }}</div>
          </div>
          <div class="value minute">
            <div class="digits">
              <div class="digit" v-for="entry in remaining.minutes" :key="entry">{{ entry }}</div>
            </div>
            <div class="label">{{ labelTextMinute }}</div>
          </div>
          <div class="value seconds">
            <div class="digits">
              <div class="digit" v-for="entry in remaining.seconds" :key="entry">{{ entry }}</div>
            </div>
            <div class="label">{{ labelTextSeconds }}</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="frame">
        <div class="message">{{ message }}</div>
        <div class="counter" :class="counterclass">
          <div class="value day">
            <div class="digits">
              <div class="digit">&nbsp;</div>
              <div class="digit">&nbsp;</div>
            </div>
            <div class="label">{{ labelTextDay }}</div>
          </div>
          <div class="value hour">
            <div class="digits">
              <div class="digit">&nbsp;</div>
              <div class="digit">&nbsp;</div>
            </div>
            <div class="label">{{ labelTextHour }}</div>
          </div>
          <div class="value minute">
            <div class="digits">
              <div class="digit">&nbsp;</div>
              <div class="digit">&nbsp;</div>
            </div>
            <div class="label">{{ labelTextMinute }}</div>
          </div>
          <div class="value seconds">
            <div class="digits">
              <div class="digit">&nbsp;</div>
              <div class="digit">&nbsp;</div>
            </div>
            <div class="label">{{ labelTextSeconds }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import { getTimedOfferById } from '~/composables/ExpApi/expTimedOffer';
import { ref } from 'vue'
const props = defineProps({
  timedOffer: String,
  message: String,
  counterclass: String,
  labelTextDay: String,
  labelTextHour: String,
  labelTextMinute: String,
  labelTextSeconds: String,
});

const remaining: Ref<CountdownResult> = ref({
  days: [],
  hours: [],
  minutes: [],
  seconds: [],
  isempty: true
});

const { pending, data: time } = await getTimedOfferById(props?.timedOffer || "");

interface CountdownResult {
  days: string[]
  hours: string[]
  minutes: string[]
  seconds: string[]
  isempty: boolean
}

const emit = defineEmits(['invalidCountdown'])

function calculateRemainingTime() {
  if (remaining?.value !== null && remaining?.value !== undefined) {
    let currentTime = (new Date().getTime() / 1000)
    let newTimedOffer = (time.value / 1000)
    let remainingTime = newTimedOffer - currentTime;
    
    if(currentTime > newTimedOffer) {
      emit('invalidCountdown');
    }

    if (remainingTime > 0)
      remaining.value.isempty = false
    else
      remaining.value.isempty = true

    remaining.value.days = Math.floor(remainingTime / (60 * 60 * 24)).toString().split("")
    remaining.value.hours = Math.floor((remainingTime % (60 * 60 * 24)) / (60 * 60)).toString().split("")
    remaining.value.minutes = Math.floor((remainingTime % (60 * 60)) / 60).toString().split("")
    remaining.value.seconds = Math.floor(remainingTime % 60).toString().split("")
    for (const [_key, value] of Object.entries(remaining?.value)) {
      if (value?.length == 1) {
        value.unshift('0')
      }
    }
  }
}

const intervla = ref();
onMounted(() => {
  calculateRemainingTime()
  intervla.value = setInterval(() => { calculateRemainingTime() }, 1000)
});

onBeforeRouteLeave(() => {
  clearInterval(intervla.value);
});

</script>
<style lang="postcss" scoped>
  .c-startpage-hero-element-countdown {
    @apply pb-1 lg:py-8;
    & .frame {
      @apply flex flex-col gap-1 lg:gap-2;
    }
    & .message {
      @apply text-xs lg:text-base text-left justify-between font-bold;
    }
    & .counter {
      @apply flex gap-3 lg:gap-4;
    }
    & .value {
      @apply text-center flex lg:block flex-col gap-0 lg:gap-1 w-10 lg:w-auto justify-center items-center;
      & .digits {
        @apply flex gap-0 font-FoundationSans justify-center text-[24px] lg:text-3xl bg-primary rounded w-10 lg:w-[50px] px-0 lg:px-2.5 items-center;
      }
    }
    & .digit {
      @apply inline-block text-primary-contrast translate-y-0.5 lg:translate-y-0 bg-transparent mb-0 lg:mb-0.5 lg:mt-2 px-0 py-0;
    }
    & .label {
      @apply uppercase text-[8px] text-center lg:text-[0.6rem] font-bold lg:max-w-full lg:text-nowrap lg:overflow-visible lg:pt-1;
    }
  }
</style>